<template>
    <div>
        <input
            required
            :autocomplete="autoComplete"
            :placeholder="placeholder"
            :type = type
            :maxlength="maxLength"
            :minlength="minLength"
            :title="title"
            :value='value'
            @input="$emit('input',$event.target.value)"
            
        >
    </div>
</template>

<script>
    export default {
        model:{
            prop:'value'
        },
        props: {
            autoComplete: {
                type: String,
            },
            placeholder: {
                type: String,
            },
            id: {
                type: String,
            },
            type: {
                type: String,
            },
            minLength: {
                type: String,
            },
            maxLength: {
                type: String,
            },
            title: {
                type: String,
            },
            value: {
                type: [String,Number]
            },
        },
    }
</script>

<style lang="css" scoped>

input {
        background-color: var(--main-red-light);
        background: var(--main-red-light);
        border: 2px solid transparent;
        border-radius: 0.5rem;
        font-weight: 500;
        padding: 0.5rem;
        width: 100%;
        margin-bottom:.6rem;
    };
        :focus {
            outline: none;
        }
        ::placeholder {
            color: var(--main-black);
        }
</style>